module.exports = __webpack_public_path__ + "img/qrmenupay.38915e74.png";